import React, { useMemo, useState } from "react";
import { useTwilanswerAppAction } from "../../hooks/useCallAction";
import TwilanswerAppUI from "./TwilanswerAppUI";
import { useRouteConfigModals } from "../contexts/RouteConfigModalsContext";
import { useOrgUsers } from "../../hooks/useOrgUsers";
import { listOrgUsersForDeviceForward } from "../../utils/forwardDeviceDestinations";

/**
 * Twilanswer App — ring a user's registered mobile devices.
 * @param {string} context - 'root' | 'offHours' (defaults to 'root')
 */
const TwilanswerApp = ({
  setOpenConfigureSlotModal,
  route,
  setRoute,
  context = "root",
  hasValidationError = false,
}) => {
  const routeModals = useRouteConfigModals();
  const [localRecordings] = useState(
    () => JSON.parse(localStorage.getItem("organization"))?.recordings?.L || []
  );
  const [localOrg] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("organization"));
    } catch {
      return null;
    }
  });
  const recordings = routeModals?.recordings ?? localRecordings;
  const orgId =
    localOrg?.orgId?.S ?? localOrg?.orgId ?? null;
  const { users: apiUsers } = useOrgUsers(orgId);
  const users = useMemo(
    () => listOrgUsersForDeviceForward(localOrg, apiUsers),
    [localOrg, apiUsers]
  );

  const appLogic = useTwilanswerAppAction(context, route, setRoute);

  const addRecordingOption = routeModals
    ? {
        label: "Add Recording",
        onClick: () =>
          routeModals.openAddRecordingModal(appLogic.handleRecordingChange),
      }
    : undefined;

  return (
    <TwilanswerAppUI
      {...appLogic}
      setOpenConfigureSlotModal={setOpenConfigureSlotModal}
      recordings={recordings}
      users={users}
      hasValidationError={hasValidationError}
      addRecordingOption={addRecordingOption}
    />
  );
};

export default TwilanswerApp;
